import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70b24a99&scoped=true&lang=html&"
import script from "./selectAddress.js?vue&type=script&lang=js&"
export * from "./selectAddress.js?vue&type=script&lang=js&"
import style0 from "./selectAddress.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./resetVant.styl?vue&type=style&index=1&id=70b24a99&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b24a99",
  null
  
)

export default component.exports